module.exports = __webpack_public_path__ + "static/media/Quicksand-VariableFont_wght.f9baef8a.ttf";